export default __webpack_public_path__ + "static/communication-system-overhaul-53fb7dd70557ab6bf10077cf146f18c0.svg";